<!-- <footer
  class="rp_footerwrap"
  [style.background-color]="companyInfo.appTheme.primaryColor"
  *ngIf="appState.companyInfo$ | async as companyInfo"
>
  <div class="report-footer">
    <div class="rp_footer_sec1">
      <h4>
        {{ companyInfo.name }}
      </h4>
      <p class="mb-0">
        {{companyInfo.defaultAgentOrLoName}} <br />
        {{ companyInfo?.phone?.displayText }}
      </p>
    </div>

    <div class="rp_footer_sec2">
      <a [href]="companyInfo?.siteUrls?.home?.link" target="_blank">
        <img [src]="companyInfo?.logo?.light" class="img-fluid" alt="Company Logo" />
      </a>
    </div>
  </div>
  <div class="rp_footer_policy">
    <span> © {{ currentYear }} {{ companyInfo.name }}.com LLC. All Rights Reserved. </span>
  </div>
</footer> -->

<footer
  class="rp_footerwrap"
  [style.background-color]="companyInfo.appTheme.primaryColor"
  *ngIf="appState.companyInfo$ | async as companyInfo"
>
  <div class="footer-top">
    <div class="footer-left">
      <h3>{{ companyInfo.name }}</h3>

      <div class="footer-info">
        <div class="info-row" *ngIf="companyInfo?.defaultAgentOrLoName">
          <span class="icon">
            <i class="fa fa-user"></i>
          </span>
          <span>{{ companyInfo.defaultAgentOrLoName }}</span>
        </div>

        <div class="info-row" *ngIf="companyInfo?.phone?.displayText">
          <span class="icon">
            <i class="fa fa-phone"></i>
          </span>
          <span>{{ companyInfo?.phone?.displayText }}</span>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- <div class="footer-right">
      <a [href]="companyInfo?.siteUrls?.home?.link" target="_blank">
        <img [src]="companyInfo?.logo?.light" alt="Company Logo" class="footer-logo" />
      </a>
    </div> -->

    <div class="footer-right">
      <a [href]="companyInfo?.siteUrls?.home?.link" target="_blank" rel="noopener noreferrer">
        <img [src]="companyInfo?.logo?.light" alt="Company Logo" class="footer-logo" />
      </a>

      <img
        src="/assets/images/equal-housing-opportunity.png"
        alt="Equal Housing Opportunity"
        class="equal-housing-logo"
      />
    </div>
  </div>

  <div class="footer-bottom">© {{ currentYear }} {{ companyInfo.name }}.com LLC. All Rights Reserved.</div>
</footer>
